import {SyncedRemoteCollectionStore, StoreBuilder} from '@softline/core';
import {Pruefprotokoll} from '../types/pruefprotokoll';

export const PruefprotokollStore =
  new StoreBuilder(SyncedRemoteCollectionStore.create<Pruefprotokoll>())
  .value;

